module.exports = __webpack_public_path__ + "img/cover-bg-2.1b93f2a3.png";